import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Project from './pages/Project'
import Certificate from './pages/Certificate'
import CreatorProfile from './pages/CreatorProfile'
import ReviewerProfile from './pages/ReviewerProfile'
import Browse from './pages/Browse'
import Wall from './pages/Wall'
import ReviewQueue from './pages/ReviewQueue'
import FAQ from './pages/FAQ'
import Admin from './pages/Admin'
import AdminSettings from './pages/AdminSettings'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import UsernameSetup from './pages/UsernameSetup'
import ProfileSettings from './pages/ProfileSettings'
import './styles/global.css'

function UsernameGuard({ children }) {
  const { user, profile, loading } = useAuth()
  const location = useLocation()
  if (loading) return <div style={{ textAlign: 'center', padding: 80 }}><span className="loading-spinner" /></div>
  if (!user) return children
  if (profile && !profile.username_set && location.pathname !== '/setup') {
    return <Navigate to="/setup" replace />
  }
  return children
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <UsernameGuard>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/setup" element={<UsernameSetup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings/profile" element={<ProfileSettings />} />
          <Route path="/project/:projectId" element={<Project />} />
          <Route path="/certificate/:uniqueId" element={<Certificate />} />
          <Route path="/u/:username" element={<CreatorProfile />} />
          <Route path="/reviewer/:reviewerUsername" element={<ReviewerProfile />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/wall" element={<Wall />} />
          <Route path="/review" element={<ReviewQueue />} />
          <Route path="/pricing" element={<Navigate to="/wall" replace />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </UsernameGuard>
    </>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  )
}